import React, { useRef, useState } from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css/pagination";
import "swiper/swiper.css";
import "swiper/css/navigation";
import "./swiper-fix.css";

// import required modules
import { Pagination, Navigation } from "swiper/modules";
import { s3baseUri } from "../../config/config";

function MediaSwiper({ data, slidesPerView = 2 }) {
  console.log(data, "data");
  return (
    <>
      <Swiper
        slidesPerView={slidesPerView}
        slidesPerGroup={slidesPerView}
        navigation={true}
        spaceBetween={30}
        pagination={{
          clickable: true,
        }}
        modules={[Pagination, Navigation]}
        className="media-swiper mySwiper"
      >
        {data.map((image, index) => (
          <SwiperSlide key={index}>
            <div className="achievement-card">
              <img
                src={s3baseUri + image?.assets?.thumbnail_4}
                alt={"achievement-image"}
                className="achievement-image"
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </>
  );
}

export default MediaSwiper;
